import _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TransformService {

  constructor() { }

  transform(body) {
    if(_.isArray(body)) {
      return this.transformArray(body);
    } else if(_.isObject(body)) {
      return this.transformObject(body);
    } else if(_.isString(body)) {
      return this.transformString(body);
    } else {
      return body;
    }
  }

  transformArray(array) {
    return _.map(array, (element) => {
      return this.transform(element);
    });
  }

  transformObject(obj) {
    const result = {};
    _.forEach(obj, (value, key) => {
      result[key] = this.transform(value);
    });
    return result;
  }

  transformString(str) {
    str = _.replace(str, /(<)+/gi, '&lt;');
    str = _.replace(str, /(>)+/gi, '&gt;');
    var span = document.createElement("span");
    span.innerHTML = str;
    return span.textContent;
  }
}
